<template>
<!-- 作品列表 -->
   <div class="list">
       <!-- 标题 -->
       <div class="tit">
           <img src="../assets/zuop.png" alt="###">
           <h1>作品列表</h1>
       </div>
       <!-- 标题2 -->
       <div class="els">
           <img class="imgleft" src="../assets/titleft.png" alt="###">
           <img class="imgels" src="../assets/titlogo.png" alt="###">
           <img class="imgright" src="../assets/titright.png" alt="###">
       </div>

  <div class="listcont">
       <div  v-for="(item,index) in listconts" :key="item.id" class="kelist">
         <div @click="wkson(index)" class="kelist-img1">
  <img class="kelist-img1"  :src="'http://ke.yunlearning.com:8081'+listconts[index].cover_img" alt="###">
         </div>

           <p class="listp">{{listconts[index].title}}</p>
           <span class="sp1">作品编号：A{{listconts[index].number}}</span><span class="sp2">{{listconts[index].praise}} 票</span>
           <div v-if="item.is_praise == 1" class="btp-cons">
             <div @click.once="btntp($event,index)" class="btntas" >
             <span class="toupysaa">{{toup}}</span>

             </div>
             <i class="btntp-icons"></i>
           </div>
           <div  v-if="item.is_praise == 0" class="btp-con">
             <div @click.once="btntp($event,index)" class="btnta" >
             <span class="toupysa">{{toups}}</span>

             </div>
             <i class="btntp-icon"></i>
           </div>
       </div>
  </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
  data(){
      return{
        listconts:[

        ],
        homepageapis:[],
        toup:"您已投过票",

        btncolor:'btnta',
        btncolor2:'btnta2',
        ispraise:[],
        toups:'为TA投票',
        parseall:[]

      }
  },
  // computed:{
  //   parsea:function(){
  //     return this.parseall
  //   }
  // },
  mounted(){
 this.onLoad();

},
methods: {
    onLoad(){
      if (JSON.parse(localStorage.getItem("userinfo")) ==null) {
           axios({
  method:'get',
  url:this.$apiUrl,
  // timeout: 1000,

}).then(res=> {
  let a =  JSON.stringify(res.data);
  this.homepageapis = JSON.parse(a);
  this.listconts = this.homepageapis.data.course;

}).catch(error =>{
    console.log(error);
})
      }else if (JSON.parse(localStorage.getItem("userinfo"))) {
        let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      let fas = new window.FormData;
      fas.append('token',tokens);
      axios({
  method:'post',
  url:this.$apiUrl,
  // timeout: 1000,
  data:fas
}).then(res=> {
  let a =  JSON.stringify(res.data);
  this.homepageapis = JSON.parse(a);
  this.listconts = this.homepageapis.data.course;

}).catch(error =>{
    console.log(error);
})
      }

},
// 点赞
btntp($event,index){
  let id = this.listconts[index].id; //作品ID

 //let grid = JSON.parse(sessionStorage.getItem('grid'));//个人作品ID

 //  console.log(grid,'grid')
  if (JSON.parse(localStorage.getItem("userinfo"))==null) {
    this.$confirm('请先登录', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.$router.push({path:'/denglu'});
    })
  }
//else if (grid !==undefined && id == grid) {
//   this.$message.error({
//     message:'自己的作品自己不能投票！！！',
//     offset:200
//   })
//   return false;
// }
else if (JSON.parse(localStorage.getItem("userinfo")) !==null) {


//获取点击对象
var elf = $event.currentTarget;


let token = JSON.parse(localStorage.getItem("userinfo")).token;
let postdata = this.$qs.stringify({
     id:id,
     token:token
});
  axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/user/praise',
 data: postdata
}).then(res=>{

  if (res.data.code==0){
//  $event.target.innerHTML = ' 您已投过票';

  this.$message.error({
    message:'今日投票次数已用完，请明天再来！',
    offset:200
  });
  }else if (res.data.code==1) {
    // $event.target.innerHTML = '投票成功';
    this.onLoad();
this.$message({
  message:'投票成功！！！',
  offset:200,
  type:'success'
});
  }

}).catch(error=>{
  // console.log(error);
})
  }
},
wkson(index){
// 将作品ID储存到VUEX中
this.$store.commit('zuopbtnId',this.listconts[index].id);
if (JSON.parse(localStorage.getItem("userinfo"))==null) {
  this.$confirm('请先登录', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    this.$router.push({path:'/denglu'});
  })

}else if (JSON.parse(localStorage.getItem("userinfo")).token) {
   this.$router.push({path:'/ptson'});
 let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
   if (rzstutas== -1) {
        this.$router.go(0);
   }
}
}

}

}
</script>

<style>
/* 作品列表标题 */
 .list{
     width: 100%;
     height: 11rem;
     background: url('../assets/bg.png')no-repeat;
}
 .tit,.els{
     text-align: center;
     margin-top: 0.32rem;
}
 .tit>img,.tit>h1{
     display: inline-block;
     vertical-align: middle;
}
 .tit>h1{
     font-size: 0.32rem;
     font-weight: bold;
     color: #000000;
}
/* 英文标题 */
 .imgleft,.imgright{
     margin-bottom: 0.07rem;
}
 .imgleft{
     margin-right:0.3rem ;
}
 .imgright{
     margin-left: 0.3rem;
}
/* 课程列表展示 */
 .listcont{
     width: 14.98rem;
     height: 9.35rem;
     margin: 0 auto;
     margin-top: 0.32rem;
     display: flex;
     justify-content:space-between;
     flex-wrap: wrap;
}
 .kelist{
     width: 3.4rem;
     height: 4.09rem;
     position: relative;
     background: #FFFFFF;
     border: 1px solid #EFF0F1;
     border-radius: 0.05rem;
}
 .kelist:hover{
     cursor: pointer;
}
 .kelist-img1{
     width: 3.4rem;
     height: 2.19rem;
}
 .kelist>p{
     font-size: 0.2rem;
     font-weight: 500;
     color: #000000;
     margin-top: 0.18rem;
     padding-left: 0.1rem;
}
 .sp1,.sp2{
     font-size: 0.16rem;
     font-weight: 400;
     color: #767676;
     position: absolute;
}
 .sp1{
     display: inline-block;
     height: 0.34rem;
     background: #F7F7F7;
     border-radius: 0.03rem;
     left: 0.2rem;
     line-height: 0.34rem;
     padding: 0 0.08rem 0 0.08rem;
     bottom: 0.95rem;
}
 .sp2{
     right: 0.24rem;
     bottom: 1.06rem;
}
 .btnta,.btp-con{
     width: 1.46rem;
     height: 0.47rem;
     line-height: 0.47rem;
     margin: 0.77rem auto;
     background-color: #007BE6;
     border-radius: 0.24rem;
     text-align: center;
     font-size: 0.16rem;
     font-weight: 500;
     color: #FFFFFF;
}
/* 投过票 */
 .btntas,.btp-cons{
     width: 1.46rem;
     height: 0.47rem;
     line-height: 0.47rem;
     margin: 0.77rem auto;
     background-color: gray;
     border-radius: 0.24rem;
     text-align: center;
     font-size: 0.16rem;
     font-weight: 500;
     color: #FFFFFF;
}
 .toupysaa{
     margin-left: 0.15rem;
}
 .btnta>:hover{
     cursor: pointer;
}
 .btp-con{
     position: relative;
}
 .btp-cons{
     position: relative;
}
 .btntp-icon,.btntp-icons{
     display: inline-block;
     width: 0.22rem;
     height: 0.2rem;
     background: url("../assets/toupiao2.png");
     background-size: 100% 100%;
     vertical-align: middle;
     margin-bottom: 0.02rem;
     position: absolute;
     top: 0.14rem;
     left: 0.15rem;
}
 .btnta span{
     margin-left: 0.17rem;
}
 .btnta2{
     width: 1.46rem;
     height: 0.47rem;
     line-height: 0.47rem;
     margin: 0.77rem auto;
     background-color: gray;
     border-radius: 0.24rem;
     text-align: center;
     font-size: 0.16rem;

     font-weight: 500;
     color: #FFFFFF;
}
 .btnta2>:hover{
     cursor: pointer;
}
 .btnta2>img{
     vertical-align: middle;
     margin-bottom: 0.02rem;
}

</style>



// WEBPACK FOOTER //
// src/components/List.vue